var exports = {
  "p": "xa15a2ab7--b9d0f3--hidden-block-segment",
};

module.exports = exports;
